import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { map, tap } from 'rxjs/operators';
import { BASE_URL } from '../config';
import swal from 'sweetalert2';


@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    private http: Http
  ) { }


  postContato(form: object) {
    const url = `${BASE_URL}contato.php`;

    return this.http.post(url, form).pipe(
      map( res => res.json() )
    );

  }

  postCurriculo(form: object) {
    const url = `${BASE_URL}curriculo.php`;

    return this.http.post(url, form).pipe(
      map( res => res.json() )
    );

  }

  listVagas() {

    const url = `${BASE_URL}vagas.php`;

    return this.http.get(url).pipe(
      map( res => res.json() )
    );

  }

  callAlert(title, msg, type) {

    return swal({
      title: title,
      text: msg,
      type: type
    });

  }

}
